import PropTypes from 'prop-types';

export const Amenity = PropTypes.shape({
  displayName: PropTypes.string.isRequired,
  imageURL: PropTypes.string.isRequired,
});

export default Amenity;
